// This regex is given by Backend Team
export const PLAYER_REGEX = /^[a-z][a-z0-9]{3,10}[a-z0-9]$/

export const PIXEL_EVENTS = {
    // Event status = 2, Banner Redirection Service
    downloadAction: 'DownloadAction',
    firstView: 'FirstView',
    contact: 'Contact',
    // Event status = 1, Landing API Service
    registration: 'Registration',
    promoClaim: 'PromoClaim',
    firstDeposit: 'FirstDeposit',
    redeposit: 'Redeposit',
    purchase: 'Purchase',
    firstWithdrawal: 'FirstWithdrawal',
    withdrawal: 'Withdrawal',
}

export const PIXEL_STORAGE_KEYS = {
    pixelId: 'pixel_id',
    bannerId: 'banner_id',
    bannerAdType: 'banner_ad_type',
    pixelExpiredStorage: 'pixel_expired_at',
}
